//import axios from 'axios'
import axios from './axiosConfig'

export default {

/**
 * Sends the data entered by the user to the create Project Controller.
 *
 */

	async createConfiguration(payload){
		
		return await axios({
				url: 'configurations/store', 
				data: JSON.parse(JSON.stringify(payload)),
				method: 'POST',
			});
	},

/**
 * Receives the project data from the return project controller
 *
 */	
	async returnRooms(){
		return axios.post('configurations/rooms')
	    	.then(response => {
	  			return response.data;
		});
	},
	
	async returnConfiguration(payload){
		return await axios({
				url: 'configurations/return', 
				data: JSON.parse(JSON.stringify(payload)),
				method: 'POST'
			});
	}
}